function getServiceFromUrl() {
    const url = window.location.href;
    if(url != ""){
      if (url.includes("checkin")) {
        return "OnlineCheckin";
      } else if(url.includes("vehicleincidents")){
        return "DAMAGE VIR"
      } else {
        return "MJP";
      }
    }
    
    }
  
  export default getServiceFromUrl;
  